import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=2a41bc94&"
import script from "./Product.vue?vue&type=script&lang=js&"
export * from "./Product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a41bc94')) {
      api.createRecord('2a41bc94', component.options)
    } else {
      api.reload('2a41bc94', component.options)
    }
    module.hot.accept("./Product.vue?vue&type=template&id=2a41bc94&", function () {
      api.rerender('2a41bc94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/battery-store/products/Product.vue"
export default component.exports